import React from 'react';
import './Headline.css';

interface Props {
  title: string,
  subtitle?: string,
}

const Headline : React.FC<Props> = ({ title, subtitle }) => {
  return (
    <header className="headline">
      <h1 className="headline__title">{title}</h1>
      {subtitle && <p className="headline__subtitle">{subtitle}</p>}
    </header>
  );
};

export default Headline;
